import { getColorValue, getFirstLinkedItemOrDefault, getTextItemValue, MEMBERSHIP_MODELS } from "@r-and-a-shared-ui/common-kontent-client";
import { getFirstMappedLinkedItemOrDefault } from "./utils/component-mapping-helpers";

export const referral_code_panel = (
  entry: MEMBERSHIP_MODELS.ReferralCodePanel,
) => {
  if (!entry || !entry.elements) {
    return undefined;
  }

  const { elements } = entry;
  const rawImage = elements.background_image?.value?.[0];

  const adaptedImage = rawImage ? {
    imageUrl: rawImage.url,
    license: 'default-license',
    width: rawImage?.width || 100,
    height: rawImage?.height || 100,
    alt: rawImage.name,
  } : null;

  return {
    title: elements.title.value,
    titleColor: getColorValue(
      getFirstLinkedItemOrDefault(elements?.title_color),
    ),
    titleFont: getTextItemValue(
      getFirstLinkedItemOrDefault(elements?.title_font),
    ),
    text: elements.text.value,
    textColor: getColorValue(
      getFirstLinkedItemOrDefault(elements?.text_color),
    ),
    textFont: getTextItemValue(
      getFirstLinkedItemOrDefault(elements?.text_font),
    ),
    cta: getFirstMappedLinkedItemOrDefault(elements.cta),
    ctaColor: getColorValue(
      getFirstLinkedItemOrDefault(elements?.cta_color),
    ),
    backgroundImage: adaptedImage,
    backgroundColor: getColorValue(
      getFirstLinkedItemOrDefault(elements?.background_color),
    ),
  };
}

export default referral_code_panel;